/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {  FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AddDayDetailsFormValues } from "src/models/AddDayDetails.model";
import ATMMarkdownContainer from "src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<AddDayDetailsFormValues>;
  editorValue?: any;
};

const SingleDayLayout = ({
  formikProps,
  editorValue = "",
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col gap-6 p-2 border m-2">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium text-primary-main">{values?.day} Details</div>
      
      </div>
      <div className="flex flex-col gap-4">
        {/* Notes */}
        <div className=" w-full">
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
          Notes
        </div>
        <ATMMarkdownContainer markdown={values?.notes} />
        </div>
        {/* Example And Script */}
        <div >
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
        Example And Script  
        </div>
        <ATMMarkdownContainer markdown={values?.exampleAndScript} />
        </div>
       <div>
       <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
          Resources
        </div>
        <div className="mt-1">
      {values?.resources?.map((el:any , ind:any)=>{
        return(
            <div className="my-3">
                  <ATMTextField 
                  disabled
                            name={`resources`}
                            value={el?.name}
                            onChange={(e) =>
                              setFieldValue(
                                `resources`,
                                e.target.value
                              )
                            }
                            onBlur={handleBlur}
                          />
            </div>
        )
      })}
        </div>
       </div>

    {/* Remark */}
    <div className=''>
      <ATMTextArea
        name='remark'
        value={values?.remark || ''}
        onChange={(e:any) => setFieldValue('remark', e)}
        label='Remark'
        placeholder='Enter Remark'
        onBlur={handleBlur}
      />
    </div>
      </div>
      <div className="flex justify-end">
        <ATMLoadingButton className="w-40" isLoading={isSubmitting} type="submit">
          Add  Remark
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default SingleDayLayout;
